export const getHeaders = () => {
  return {
    authorization: 'Bearer ' + window.localStorage.getItem('token'),
  }
}